module.exports = __webpack_public_path__ + "static/media/teamBannerOne.53ca8e56.png";